export default __webpack_public_path__ + "static/media/pg.7adbf4e1.jpg";